import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PubSvg = function PubSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.145 6.5 17 2.355V6.25a.25.25 0 0 0 .25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.78 6.425 17.075 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5a.75.75 0 0 0 .75.75h14.5a.75.75 0 0 0 .75-.75V6.955a.76.76 0 0 0-.22-.53M17 2.355 21.145 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#038387",
    d: "M12 7.5H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M9.44 10.5a2.38 2.38 0 0 0-1.605-.5H5.5v6h1.145v-2.12H7.76a2.6 2.6 0 0 0 1.18-.255c.325-.156.597-.402.785-.71a1.96 1.96 0 0 0 .275-1.04 1.73 1.73 0 0 0-.56-1.375m-1.795 2.46h-1l.02-2.04h1c.755 0 1.13.34 1.13 1a1 1 0 0 1-.295.775 1.24 1.24 0 0 1-.855.265",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#038387",
    d: "M19.75 15H14v.5h5.75a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A9BA1",
    d: "M19.75 13.5H14v.5h5.75a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37C6D0",
    d: "M14 10.5h5.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H14z"
  }));
};
export var Pub = function Pub(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PubSvg
  }));
};